// ══════════════════════════════════════════════════════
// PeptideVault v6.5 — Inventory Forecasting
// Forward-looking planning intelligence with explainable calculations.
// Replaces the simple allocation view with full forecasting.
// ══════════════════════════════════════════════════════

var _forecastWindow = 90
var _forecastDetail = null  // peptideId to show detail for

function setForecastWindow(days) { _forecastWindow = days; render() }
function showForecastDetail(peptideId) { _forecastDetail = _forecastDetail === peptideId ? null : peptideId; render() }

function renderInventoryForecastTab() {
  var horizon = protocolPlanningHorizon()
  _forecastWindow = horizon.days
  var results = forecastInventory(S.protocols||[], S.peptides||[], S.inventoryReservations||[], _forecastWindow)
  var plan = purchasePlan(results)
  var today = new Date()
  var endStr = horizon.end

  var totalOnHand = results.reduce(function(s,r){return s+r.onHand},0)
  var totalReserved = results.reduce(function(s,r){return s+r.reserved},0)
  var totalShortfall = results.filter(function(r){return r.shortfall>0}).length
  var totalExpiring = results.reduce(function(s,r){return s+r.expiringBeforeEnd},0)

  return '<div class="tab-content" style="animation:fadeIn .25s ease">' +
    '<div class="row" style="margin-bottom:16px;flex-wrap:wrap;gap:8px;align-items:center">' +
      '<h2 style="font-size:20px;font-weight:700">Inventory Forecast</h2>' +
      '<div class="spacer"></div><span class="badge badge-blue">Current month + next 2</span>' +
    '</div>' +

    // Summary cards
    '<div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(130px,1fr));gap:10px;margin-bottom:16px">' +
      '<div class="card" style="padding:12px;text-align:center">' +
        '<div style="font-size:22px;font-weight:700;color:var(--blue)">' + totalOnHand + '</div>' +
        '<div style="font-size:11px;color:var(--text4)">Total On Hand</div>' +
      '</div>' +
      '<div class="card" style="padding:12px;text-align:center">' +
        '<div style="font-size:22px;font-weight:700;color:var(--amber)">' + totalReserved + '</div>' +
        '<div style="font-size:11px;color:var(--text4)">Reserved</div>' +
      '</div>' +
      '<div class="card" style="padding:12px;text-align:center">' +
        '<div style="font-size:22px;font-weight:700;color:' + (totalShortfall>0?'var(--red)':'var(--green)') + '">' + totalShortfall + '</div>' +
        '<div style="font-size:11px;color:var(--text4)">Shortfalls</div>' +
      '</div>' +
      '<div class="card" style="padding:12px;text-align:center">' +
        '<div style="font-size:22px;font-weight:700;color:' + (totalExpiring>0?'var(--amber)':'var(--text4)') + '">' + totalExpiring + '</div>' +
        '<div style="font-size:11px;color:var(--text4)">Expiring in Window</div>' +
      '</div>' +
    '</div>' +

    // Forecast table
    '<div class="card" style="padding:0;overflow:hidden">' +
      '<div style="padding:10px 14px;background:var(--bg3);border-bottom:1px solid var(--border2);font-size:12px;color:var(--text3)">' +
        'Forecast window: ' + horizon.start + ' → ' + endStr + ' (' + _forecastWindow + ' days)' +
      '</div>' +
      (results.length === 0 ?
        '<div class="empty-state" style="padding:32px"><div class="empty-icon">📊</div><p>No active protocols to forecast</p><p style="font-size:12px;color:var(--text4)">Create a protocol with status Active to see inventory projections.</p></div>' :
        results.map(function(r, i) {
          var isDetail = _forecastDetail === r.peptideId
          var shortfallColor = r.shortfall > 0 ? 'var(--red)' : r.shortfall === 0 ? 'var(--green)' : 'var(--text4)'

          return '<div style="' + (i>0?'border-top:1px solid var(--border2)':'') + '">' +
            '<div style="display:grid;grid-template-columns:2fr repeat(6,1fr);gap:8px;align-items:center;padding:10px 14px;cursor:pointer" onclick="showForecastDetail(\'' + r.peptideId + '\')">' +
              '<div>' +
                '<div style="font-size:13px;font-weight:600">' + esc(r.peptideName) + '</div>' +
                '<div style="font-size:11px;color:var(--text4)">' + r.totalDoses + ' planned doses</div>' +
              '</div>' +
              '<div style="text-align:center"><div style="font-size:14px;font-weight:600;color:var(--blue)">' + r.onHand + '</div><div style="font-size:9px;color:var(--text4)">On Hand</div></div>' +
              '<div style="text-align:center"><div style="font-size:14px;font-weight:600;color:var(--amber)">' + r.reserved + '</div><div style="font-size:9px;color:var(--text4)">Reserved</div></div>' +
              '<div style="text-align:center"><div style="font-size:14px;font-weight:600;color:var(--green)">' + r.available + '</div><div style="font-size:9px;color:var(--text4)">Available</div></div>' +
              '<div style="text-align:center"><div style="font-size:14px;font-weight:600">' + (r.canCalculate ? r.totalAmount + ' ' + r.amountUnit : r.totalDoses + ' doses') + '</div><div style="font-size:9px;color:var(--text4)">Required</div></div>' +
              '<div style="text-align:center"><div style="font-size:14px;font-weight:600">' + (r.vialsNeeded !== null ? r.vialsNeeded : '\u2014') + '</div><div style="font-size:9px;color:var(--text4)">Vials Needed</div></div>' +
              '<div style="text-align:center"><div style="font-size:14px;font-weight:700;color:' + shortfallColor + '">' + (r.shortfall !== null ? (r.shortfall > 0 ? '-' + r.shortfall : '\u2713') : '?') + '</div><div style="font-size:9px;color:var(--text4)">Shortfall</div></div>' +
            '</div>' +

            // Expandable detail section
            (isDetail ? '<div style="padding:0 14px 14px;background:var(--bg3)">' +
              '<div style="display:grid;grid-template-columns:1fr 1fr;gap:12px">' +

                // Calculation breakdown
                '<div style="background:var(--bg);border-radius:var(--r2);padding:12px">' +
                  '<div style="font-size:11px;font-weight:700;color:var(--text4);text-transform:uppercase;margin-bottom:6px">Calculation Detail</div>' +
                  '<div style="font-size:12px;line-height:1.8">' +
                    '<div>Planned doses in window: <b>' + r.totalDoses + '</b></div>' +
                    (r.canCalculate ? '<div>Total required: <b>' + r.totalAmount + ' ' + r.amountUnit + '</b></div>' : '<div style="color:var(--amber)">Dose and vial units are not compatible</div>') +
                    (r.skuStrengths.length > 0 ? '<div>SKU strengths: ' + r.skuStrengths.map(function(s){return s.amount+' '+s.unit+' \u00d7'+s.qty}).join(', ') + '</div>' : '<div style="color:var(--amber)">No compatible SKU strength data \u2014 vial count unavailable</div>') +
                    (r.vialsNeeded !== null ? '<div>Vials needed: <b>' + r.vialsNeeded + '</b> (' + r.totalAmount + ' '+r.amountUnit+' \u00f7 avg ' + (r.skuStrengths.length>0 ? (r.skuStrengths.reduce(function(s,x){return s+x.amount*x.qty},0)/r.skuStrengths.reduce(function(s,x){return s+x.qty},0)).toFixed(1) : '?') + ' '+r.amountUnit+'/vial)</div>' : '') +
                    '<div>On hand: ' + r.onHand + ' \u2014 Reserved: ' + r.reserved + ' \u2014 Available: ' + r.available + '</div>' +
                    (r.shortfall !== null && r.shortfall > 0 ? '<div style="color:var(--red);font-weight:600">Shortfall: ' + r.shortfall + ' vials</div>' : '') +
                    (r.allocationExplanation ? '<div style="margin-top:8px;padding-top:6px;border-top:1px solid var(--border2)"><b>Reproducible allocation</b><div>Eligible after reservations: ' + r.allocationExplanation.eligibleVials + ' vial(s)</div><div>Excluded by reservation: ' + r.allocationExplanation.reservedVials + '</div><div>Expired before use: ' + r.allocationExplanation.expiredExcluded + '</div>' + (r.allocationExplanation.unmetAmount ? '<div style="color:var(--red)">Unmet requirement: ' + r.allocationExplanation.unmetAmount + ' ' + r.amountUnit + '</div>' : '') + '</div>' : '') +
                  '</div>' +
                '</div>' +

                // Expiration + timeline
                '<div style="background:var(--bg);border-radius:var(--r2);padding:12px">' +
                  '<div style="font-size:11px;font-weight:700;color:var(--text4);text-transform:uppercase;margin-bottom:6px">Expiration & Schedule</div>' +
                  '<div style="font-size:12px;line-height:1.8">' +
                    (r.earliestExpiry ? '<div>Earliest expiry: <span style="color:' + (r.earliestExpiry <= fmtLD(today) ? 'var(--red)' : r.earliestExpiry <= endStr ? 'var(--amber)' : 'var(--text3)') + '">' + r.earliestExpiry + '</span></div>' : '<div style="color:var(--text4)">No expiration dates set</div>') +
                    (r.expiringBeforeEnd > 0 ? '<div style="color:var(--amber)">' + r.expiringBeforeEnd + ' vial(s) expire before ' + endStr + '</div>' : '') +
                    '<div style="margin-top:8px;font-size:11px;color:var(--text4)">Next 5 planned dates:</div>' +
                    '<div style="font-size:11px;color:var(--text3)">' + r.events.slice(0,5).map(function(e){return e.date.slice(5) + ' ' + e.doseAmount + ' ' + e.doseUnit + (e.phaseName ? ' (' + e.phaseName + ')' : '')}).join('<br>') + '</div>' +
                    (r.allocationExplanation && r.allocationExplanation.fefo.length ? '<div style="margin-top:8px;font-size:11px;color:var(--text4)">FEFO consumption order:</div><div style="font-size:11px;color:var(--text3)">' + r.allocationExplanation.fefo.map(function(v,i){return (i+1) + '. ' + (v.skuId||'SKU') + ' · ' + (v.expiry||'no expiry') + ' · ' + v.usedMg + ' '+r.amountUnit+' used'}).join('<br>') + '</div>' : '') +
                  '</div>' +
                '</div>' +

              '</div>' +
              '<div style="margin-top:8px;display:flex;gap:6px">' +
                '<button class="btn btn-secondary btn-xs" onclick="setTab(\'allocation\')">Manage Reservations</button>' +
                '<button class="btn btn-secondary btn-xs" onclick="setTab(\'planner\')">View Protocol</button>' +
              '</div>' +
            '</div>' : '') +
          '</div>'
        }).join('')
      ) +
    '</div>' +

    // Purchase planning section
    (plan.length > 0 ?
      '<div class="card" style="margin-top:16px;padding:0;overflow:hidden">' +
        '<div style="padding:10px 14px;background:var(--bg3);border-bottom:1px solid var(--border2)">' +
          '<span style="font-size:13px;font-weight:600">Purchase Planning</span>' +
          '<span class="badge badge-amber" style="margin-left:8px">' + plan.length + ' items</span>' +
        '</div>' +
        plan.map(function(p, i) {
          return '<div style="padding:10px 14px;' + (i>0?'border-top:1px solid var(--border2)':'') + ';display:flex;gap:12px;align-items:center">' +
            '<span style="font-size:13px;font-weight:600">' + esc(p.peptideName) + '</span>' +
            '<div class="spacer"></div>' +
            (p.shortfall > 0 ? '<span style="font-size:12px;color:var(--red)">' + p.shortfall + ' vials short</span>' : '') +
            (p.expiringBeforeEnd > 0 ? '<span style="font-size:12px;color:var(--amber)">' + p.expiringBeforeEnd + ' expiring</span>' : '') +
            '<span class="badge badge-blue">Buy ' + p.suggestedQty + '</span>' +
          '</div>'
        }).join('') +
      '</div>' : '') +
  '</div>'
}

export {
  _forecastWindow,
  _forecastDetail,
  setForecastWindow,
  showForecastDetail,
  renderInventoryForecastTab
}
